import {AavoMosaic} from "src/components/common/mosaic/AavoMosaic.tsx";
import {ReclamationCustomerOrdersDataGrid} from "./ReclamationCustomerOrdersDataGrid.tsx";
import i18n from "i18next";
import {useState} from "react";
import {CustomerOrderReclamationView} from "src/api/generated/erp/db/types/tables/customerOrderReclamationView.ts";
import {CenteredTypography} from "src/components/common/CenteredTypography.tsx";
import {RefreshableElementRef} from "src/utils/useRefreshRef.ts";
import {
    ReclamationCustomerOrderLinesDataGrid
} from "src/components/views/erp/reclamation/reclamationCustomerOrders/ReclamationCustomerOrderLinesDataGrid.tsx";
import { useIsMobile } from "src/utils/breakpointUtils.ts";

export interface ReclamationCustomerOrdersViewProps {
	reclamationId: number;
	customerOrdersRefreshRef?: RefreshableElementRef;
}

export const ReclamationCustomerOrdersView = ({
	reclamationId,
	customerOrdersRefreshRef,
}: ReclamationCustomerOrdersViewProps) => {
	const isMobile = useIsMobile();

	const [selectedCustomerOrders, setSelectedCustomerOrders] = useState<
		CustomerOrderReclamationView[]
	>([]);

	const onlySelectedCustomerOrder =
		selectedCustomerOrders.length === 1 ? selectedCustomerOrders[0] : null;

	const customerOrdersDataGrid = (
		<ReclamationCustomerOrdersDataGrid
			refreshRef={customerOrdersRefreshRef}
			reclamationId={reclamationId}
			onSelectionChanged={setSelectedCustomerOrders}
		/>
	);
	if (isMobile) return customerOrdersDataGrid;

	return (
		<AavoMosaic
			viewId={"26C9C601F2C79A1"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("customer_orders"),
					content: customerOrdersDataGrid,
				},
				second: {
					type: "panel",
					title: i18n.t("customer_order_lines"),
					content:
						onlySelectedCustomerOrder == null ?
							<CenteredTypography>
								{i18n.t("select_single_customer_order")}
							</CenteredTypography>
						:	<ReclamationCustomerOrderLinesDataGrid
								key={onlySelectedCustomerOrder.customerOrderId}
								customerOrderId={onlySelectedCustomerOrder.customerOrderId}
								parentLineId={null}
							/>,
				},
			}}
		/>
	);
};
